import { Step } from 'react-joyride';

import { FINANCIAL_OVERVIEW_TOUR_CLASSES } from './classNames';

export const financialOverviewSteps: Step[] = [
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.HEADER}`,
    title: 'Welcome to Financial Overview',
    content:
      'This is your comprehensive financial hub where you can access all franchise financial information, including FDD documents and financial projections.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.TABS_LIST}`,
    title: 'Financial Information Tabs',
    content:
      'Navigate through different financial sections: Franchisee Fee, Initial Investment, Royalties & Fees, Financial Performance, and Financial Projections.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.TAB_FRANCHISEE_FEE}`,
    title: 'Franchisee Fee Information',
    content:
      'View detailed information about the franchisee fee requirements and structure directly from the FDD document.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.TAB_INITIAL_INVESTMENT}`,
    title: 'Initial Investment Details',
    content:
      'Access comprehensive initial investment requirements including all startup costs and capital requirements.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.TAB_ROYALTIES}`,
    title: 'Ongoing Fees Structure',
    content:
      'Review ongoing royalties, brand fund contributions, and technology fees that will be part of your franchise operations.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.TAB_PERFORMANCE}`,
    title: 'Financial Performance Data',
    content:
      'Analyze historical financial performance representations and benchmarks from existing franchise locations.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.TAB_PROJECTION}`,
    title: 'Financial Projection Workbook',
    content:
      'Access your personalized financial projection workbook to plan and model your franchise financial future.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.FDD_DOCUMENT_VIEWER}`,
    title: 'FDD Document Viewer',
    content:
      'Interactive PDF viewer for the Franchise Disclosure Document. You can scroll through pages and the system will automatically navigate to relevant sections based on your selected tab.',
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${FINANCIAL_OVERVIEW_TOUR_CLASSES.FDD_PAGE_INDICATOR}`,
    title: 'Page Navigation',
    content:
      'Keep track of your current location in the FDD document. The page indicator shows your current page and total pages.',
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
  },
];
